import HTTP from '@/plugins/http';

const merchantdetailsApi = {
  rechargeDeduction: '/merchant/allWallet/rechargeDeduction',
  walletTransfer: '/merchant/walletTransfer',
  amount: '/merchant/wallet/amount',

};

function doRechargeDeduction(data) {
  return HTTP.loading({
    url: merchantdetailsApi.rechargeDeduction,
    method: 'post',
    data
  });
}
export function getAmount(params) {
  return HTTP({
    url: merchantdetailsApi.amount,
    method: 'get',
    params
  });
}
function doWalletTransfer(data) {
  return HTTP.loading({
    url: merchantdetailsApi.walletTransfer,
    method: 'post',
    data
  });
}

export default { doRechargeDeduction, getAmount, doWalletTransfer };



// WEBPACK FOOTER //
// ./src/api/merchantdetails.js